import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import Styled from '../styled/Container';

const elId = 'fixter-auto-complete-container';
let containerRoot;

if (typeof window !== 'undefined') {
  containerRoot = document.getElementById(elId);
}

if (!containerRoot && typeof window !== 'undefined') {
  containerRoot = document.createElement('div');
  containerRoot.id = elId;
  document.body.appendChild(containerRoot);
}

class Container extends React.Component {
  componentDidMount() {
    disableBodyScroll(containerRoot);
  }

  componentWillUnmount() {
    enableBodyScroll(containerRoot);
  }

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(<Styled active>{children}</Styled>, containerRoot);
  }
}

Container.propTypes = {
  children: PropTypes.object,
};

Container.defaultProps = {
  children: null,
};

export default Container;

